/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IJobTitlesState } from '../../types';
import { JobTitles } from './types';

const initialState: IJobTitlesState | null = null;

export const jobsReducer: Reducer<IJobTitlesState | null> = (state = initialState, action) => {
  switch (action.type) {
    case JobTitles.GET_JOB_TITLES_SUCCESS: {
      const { siteId, response } = action.payload;

      return {
        ...state,
        [siteId]: response,
      };
    }
    case JobTitles.GET_ORG_JOB_TITLES_SUCCESS: {
      const { organizationId, response } = action.payload;

      return {
        ...state,
        [organizationId]: response,
      };
    }
    case JobTitles.RESET_JOB_TITLES: {
      return {};
    }
    default: {
      return state;
    }
  }
};
